<template>
  <div class="pagination-section">
    <div
      class="d-flex justify-content-between align-items-center p-4 border-top"
    >
      <div class="text-sm text-secondary">
        <template v-if="totalItems > 0">
          Showing {{ startItem }} to {{ endItem }} of {{ totalItems }} entries
        </template>
        <template v-else> No entries available </template>
      </div>
      <div class="pagination d-flex gap-2" v-if="totalItems > 0">
        <button
          class="btn btn-outline-secondary btn-sm"
          @click="changePage(currentPage - 1)"
          :disabled="currentPage === 1"
        >
          Previous
        </button>

        <template v-for="pageNum in displayedPages" :key="pageNum">
          <button
            v-if="pageNum !== '...'"
            class="btn btn-outline-secondary btn-sm"
            :class="{ 'btn-primary text-white': pageNum === currentPage }"
            @click="changePage(pageNum)"
          >
            {{ pageNum }}
          </button>
          <span v-else class="px-2 d-flex align-items-center">...</span>
        </template>

        <button
          class="btn btn-outline-secondary btn-sm"
          @click="changePage(currentPage + 1)"
          :disabled="currentPage === totalPages"
        >
          Next
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    totalItems: {
      type: Number,
      required: true,
      default: 0,
    },
    currentPage: {
      type: Number,
      required: true,
      default: 1,
    },
    totalPages: {
      type: Number,
      required: true,
      default: 1,
    },
    displayedPages: {
      type: Array,
      required: true,
      default: () => [1],
    },
    itemsPerPage: {
      type: Number,
      required: false,
      default: 10,
    },
  },
  computed: {
    startItem() {
      return (this.currentPage - 1) * this.itemsPerPage + 1;
    },
    endItem() {
      return Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
    },
  },
  methods: {
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.$emit("page-change", page);
      }
    },
  },
};
</script>

<style scoped>
.pagination-section {
  position: sticky;
  bottom: 0;
  background: white;
  z-index: 5;
  border-top: 1px solid #f0f0f0;
}

.pagination-number {
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  margin: 0 0.25rem;
  border-radius: 0.25rem;
}

.pagination-number:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
</style>
